module.exports = ".dit-select{min-width:100px}"